import toast from 'react-hot-toast'
import { QueryFunctionContext, useInfiniteQuery } from 'react-query'
import flatten from 'lodash/flatten'
import { SortingRule } from 'react-table'

import { experiencesPerPage } from '../utils/config'
import { Experience, ExperienceFilter } from '../types/experiences'
import experienceService from '../services/experienceService'
import { useUser } from './useUser'
import { BuzzlUsersError } from '../types/buzzl-user'

export function useExperiences(
  params: { [x: string]: any },
  filter?: ExperienceFilter,
  orderBy?: SortingRule<Experience>[]
) {
  const user = useUser()

  return useInfiniteQuery(
    ['experiences', params, filter, orderBy],
    (context: QueryFunctionContext) => {
      return experienceService.getAll(params, filter, {
        first: experiencesPerPage,
        skip: context.pageParam || 0,
        ...(orderBy && orderBy.length > 0
          ? { orderBy: `${orderBy[0].id}_${orderBy[0].desc ? 'DESC' : 'ASC'}` }
          : { orderBy: 'createdAt_DESC' }),
        //if it is not a buzzl user, display only experiences which are in its customer's place
        ...(user.data?.customerUser?.customer?.id && {
          where: {
            place: {
              customer: {
                id: user.data?.customerUser?.customer?.id,
              },
            },
          },
        }),
      })
    },
    {
      enabled: !!user.data,
      keepPreviousData: true,
      getNextPageParam: (lastPage, allPages) => {
        if (lastPage.length < experiencesPerPage) return false
        return flatten(allPages).length
      },
      onError: (e) => {
        const error = e as BuzzlUsersError
        error.response.errors.map((er) =>
          toast.error(er.message || 'Something went wrong, if the error persist please contact support.')
        )
      },
    }
  )
}
